import './RenderWeeklyMaterial.css';
import RenderWeeklyMaterial from './RenderWeeklyMaterial';

export default RenderWeeklyMaterial;
